import type { TFunction } from "i18next";
import type { ThreadSubject } from "../threadIntent";

/**
 * The generated title of a run (F31: "The title is generated"): the Workflow's name, or "New
 * Thread" without one, then what it works on: one document, its focused segment, or a count.
 * The API client fits it to the server's limit.
 */
export function runTitle(workflowName: string | null, entries: readonly ThreadSubject[], t: TFunction): string {
  const name = workflowName ?? t("threads.prepare.run.freeTitle");
  const [subject] = entries;
  if (subject === undefined) {
    return name;
  }
  if (entries.length > 1) {
    return t("threads.prepare.run.titleOnEntries", { name, count: entries.length });
  }
  const on = subject.segmentPath === undefined ? subject.label : `${subject.label} #${subject.segmentPath}`;
  return t("threads.prepare.run.titleOnDocument", { name, document: on });
}
